import Vue from "vue";
import VueI18n from 'vue-i18n/dist/vue-i18n.esm'
import messages from './index'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || 'zh',
  fallbackLocale: 'zh',
  messages
})

export default i18n


// WEBPACK FOOTER //
// ./src/lang/i18n.js